import { PdsWidget } from './pds-widget';
import { I18nUtil } from 'common-utils';
import { Time } from 'common-utils/interfaces';
import { pdsI18n } from './pds-i18n';

//Creating a special version of the i18nUtil class that will ONLY use 24 hour time for purposes of checking
//If something is a 24 hr time string.
//WARNING: DO not use this object for anything other than the isValidTime() function.
const twentyFourHourTimeFormatChecker = new I18nUtil();
//We only care about ONE value in the locale with this object.
twentyFourHourTimeFormatChecker.locale = { DATETIME_FORMATS: { shortTime: 'HH:mm'}};

export class PdsFormatTime extends PdsWidget {
  is = 'pds-format-time';
  name: string;
  dataTime: string | null;
  time: Time | Date | null;
  localizedTime: string | null;
  dataFormat: 'TIME' | 'TIME_COMPACT' | 'TIME_PAD_ZEROS';

  properties = {
    dataTime: {
      type: String,
      value: null,
      observer: 'updateTime'
    },
    time: {
      value: null,
      observer: 'updateLocalizedTime'
    },
    dataFormat: {
      type: String,
      value: 'TIME',
      observer: 'updateLocalizedTime'
    }
  };
  updateTime(): void {
    if (this.dataTime != null) {
      let isValidTime = twentyFourHourTimeFormatChecker.isValidTime(this.dataTime);
      if (isValidTime === true) {
        this.time = pdsI18n.parse24HourTime(this.dataTime);
      } else {
        this.time = null;
      }
    }
  }

  updateLocalizedTime(): void {
    if (this.time != null &&
        typeof this.time.getHours === 'function' &&
        typeof this.time.getMinutes === 'function') {
      this.localizedTime = pdsI18n.formatTime(this.time, this.dataFormat);
    } else {
      this.localizedTime = null;
    }
  }
}
